export enum TypeExportAnalyseFinanciere {
  PRESTATION = "PRESTATION",
  PLAT = "PLAT",
  FAMILLE_PRODUIT = "FAMILLE_PRODUIT"
}
